import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import NumericalInput from "../../../Components/NumericalInput";
import { formatGoogleDriveMediaLink } from "../../../Utils/Common";
import SerialisedSubAssemblyAllocation, {
  isSerialisedSubAssemblyStockItem,
} from "../SerialisedSubAssemblyAllocation";

export default function ShippingItemLine({
  item,
  onlyPrint,
  width,
  setShipmentData,
  shipmentData,
  orderData,
  serialisedSubAssemblyAllocation,
  serialisedSubAssemblyAllocationEditable,
}) {
  const { t } = useTranslation();
  width = onlyPrint ? "" : width;
  const reserveSerialisedSubAssemblyAllocationColumn =
    !!serialisedSubAssemblyAllocation;
  const showSerialisedSubAssemblyAllocation =
    reserveSerialisedSubAssemblyAllocationColumn &&
    isSerialisedSubAssemblyStockItem(item);

  /**
   *
   * @param {Object} ship
   * @returns Array
   */
  const getOriginalItems = (ship) => {
    if (!ship?.Order && !ship?.ResupplyOrder) {
      return [];
    }
    if (ship.Order) {
      return ship.Order.genericDevices;
    }
    return ship.ResupplyOrder.genericDevices;
  };

  const checkForShippedItems = (orderData) => {
    if (!orderData) {
      return 0;
    }
    var count = 0;
    if (orderData.Shipments && orderData.Shipments.length) {
      for (let index = 0; index < orderData.Shipments.length; index++) {
        const element = orderData.Shipments[index];
        if (element.status === "cancelled") {
          continue;
        }
        count =
          element?.genericDevices.find((f) => f.id === item.id).count + count;
      }
    }
    return count;
  };

  useEffect(() => {
    // Set the default value if a shipment has already been created
    if (item && shipmentData && orderData) {
      var idx = shipmentData.genericDevices.findIndex((a) => a.id === item.id);
      var obj = shipmentData.genericDevices[idx];
      obj.count = Number(item.count) - checkForShippedItems(orderData);
      var arr = [...shipmentData.genericDevices];
      arr[idx] = obj;
      setShipmentData({ ...shipmentData, genericDevices: [...arr] });
    }
  }, []);

  return (
    <Grid
      container
      style={{
        borderRadius: 5,
        backgroundColor: "#eeeeee",
        marginTop: 2,
        padding: 5,
      }}
      alignItems="center"
    >
      <Grid item xs={1} style={{ padding: 5 }}>
        <img
          alt="Item"
          src={formatGoogleDriveMediaLink(item.imageUrl)}
          width={50}
        />
      </Grid>
      <Grid item xs={3} style={{ padding: 5 }}>
        <Typography
          style={{ textDecoration: !item.count ? "line-through" : "" }}
        >
          {item.sku}
        </Typography>{" "}
      </Grid>
      <Grid
        item
        sm={3}
        xs={12}
        style={width === "xs" ? { marginBottom: 5 } : { padding: 5 }}
      >
        <Typography
          style={{ textDecoration: !item.count ? "line-through" : "" }}
        >
          {item.name}
        </Typography>
      </Grid>
      {reserveSerialisedSubAssemblyAllocationColumn ? (
        <Grid
          item
          sm={2}
          xs={12}
          style={width === "xs" ? { marginBottom: 5 } : { padding: 5 }}
        >
          {showSerialisedSubAssemblyAllocation ? (
            <SerialisedSubAssemblyAllocation
              stockItem={item}
              shipmentData={shipmentData}
              setShipmentData={setShipmentData}
              editable={serialisedSubAssemblyAllocationEditable}
            />
          ) : null}
        </Grid>
      ) : null}
      <Grid
        item
        sm={reserveSerialisedSubAssemblyAllocationColumn ? 1 : 2}
        xs={3}
        container
        justify="flex-end"
      >
        {onlyPrint ? (
          <Typography
            style={{
              textAlign: "right",
            }}
          >
            {item.count}
          </Typography>
        ) : (
          <NumericalInput
            label={t("count")}
            type="number"
            style={{ marginRight: 50 }}
            key={item.id}
            defaultValue={Number(item.count) - checkForShippedItems(orderData)}
            inputProps={{
              min: 0,
              max: Number(item.count) - checkForShippedItems(orderData),
              style: { textAlign: "right" },
            }}
            variant="outlined"
            onChange={(e) => {
              if (e.target && e.target.value) {
                if (
                  Number(e.target.value) > Number(item.count) ||
                  Number(e.target.value) < 0
                ) {
                  alert("Illegal value!");
                  return;
                }
              }
              var idx = shipmentData.genericDevices.findIndex(
                (a) => a.id === item.id,
              );
              var obj = shipmentData.genericDevices[idx];
              obj.count = Number(e.target.value);
              var arr = [...shipmentData.genericDevices];
              arr[idx] = obj;
              setShipmentData({ ...shipmentData, genericDevices: [...arr] });
            }}
          />
        )}
      </Grid>
      <Grid
        item
        sm={reserveSerialisedSubAssemblyAllocationColumn ? 2 : 3}
        xs={4}
        style={width === "xs" ? {} : { padding: 5 }}
      >
        <Typography style={{ textAlign: "left" }}>
          /{" "}
          {
            getOriginalItems(shipmentData).find(
              (a) =>
                (a.id && item.id && a.id === item.id) ||
                (a.sku && item.sku && a.sku === item.sku) ||
                (a.name && item.name && a.name === item.name),
            )?.count
          }
        </Typography>
      </Grid>
    </Grid>
  );
}
